import { render } from "./HousingBenefit.vue?vue&type=template&id=186d458f&scoped=true"
import script from "./HousingBenefit.vue?vue&type=script&lang=js"
export * from "./HousingBenefit.vue?vue&type=script&lang=js"

import "./HousingBenefit.vue?vue&type=style&index=0&id=186d458f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186d458f"]])

export default __exports__